<template>
  <div id="app">
    <router-view />
    <LoginDialog />
  </div>
</template>

<script>
import LoginDialog from '@/components/loginDialog'

export default {
  name: 'App',
  components: { LoginDialog }
}
</script>

<style lang="scss">
body {
  // overflow-y: scroll;
  padding: 0 !important;
}

html {
  box-sizing: border-box;
  overflow-y: scroll;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
}

#app {
  width: 100%;
  min-height: 100vh;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

// 分页样式全局修改
// 下拉框选中 -> 红色
.el-select-dropdown__item.selected {
  color: var(--primary) !important;
}

// pageSize下拉框 focus 边框
.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--primary) !important;
}

// 下拉框出现时的边框
.el-input.is-focus .el-input__inner {
  border-color: var(--primary) !important;
}

// 下拉选中项文字颜色（50条/页）
.el-select-dropdown__item.selected {
  color: var(--primary) !important;
}

// 下拉选中项hover
.el-select-dropdown__item:hover {
  color: var(--primary) !important;
}

.el-select .el-input__inner:focus {
  border-color: var(--primary) !important;
}

.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: var(--primary) !important;
  outline: 0;
}

.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus,
.el-message-box__input input.invalid,
.el-message-box__input input.invalid:focus {
  border-color: #a8171a;
}

.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: #a8171a !important;
}

.el-pagination button:hover {
  color: #a8171a !important;
}

.el-textarea__inner:focus {
  outline: 0;
  border-color: var(--primary) !important;
}

.el-radio.is-bordered.is-checked {
  border-color: var(--primary) !important;
}

.el-button--primary {
  color: #dedede;
  background-color: #a8171a !important;
  border: none !important;
}

.el-pager li.active {
  color: #a8171a !important;
}

.el-pager li:hover {
  color: #a8171a !important;
}

.el-loading-mask {
  z-index: 1000 !important;
}
</style>
